import React, { useContext, useState, useRef, useEffect } from "react"
import "./EditUniversity.scss"
import { useLocation, useNavigate } from "react-router-dom"
import { Button, Card, CardBody, Col, Row, Spinner } from "reactstrap"
import { InputText } from "primereact/inputtext"
import { InputNumber } from "primereact/inputnumber"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"
import { Calendar } from "primereact/calendar"
import * as Yup from "yup"
import UniversityApi from "Api/UniversityApi"
import Country from "utils/Data/Country"
import { Dropdown } from "primereact/dropdown"
import UserContext from "ContextProvider/UserContext"
import { Toast } from "primereact/toast"
import s3Upload from "Api/s3Upload"
import S3UploadApi from "Api/s3Upload"
import { Avatar } from "primereact/avatar"
import { formatDistanceToNow } from "date-fns"

const EditUniversity = () => {
  document.title = "Edit University"
  const [loading, setLoading] = useState(false)
  const accessToken = localStorage.getItem("accessToken")
  const navigate = useNavigate("")
  const location = useLocation("")
  const universityData = location?.state
  const userData = JSON.parse(localStorage.getItem("userData"))

  const toast = useRef(null)

  const [logoFile, setLogoFile] = useState(null)
  const [logoUrl, setLogoUrl] = useState(universityData?.logo?.url || "")
  const [logoAlt, setLogoAlt] = useState(universityData?.logo?.alt || "")
  const [isUploading, setIsUploading] = useState(false)
  const [isUploadingBanner, setIsUploadingBanner] = useState(false)
  const [isUploadingGallery, setIsUploadingGallery] = useState(false)

  const [errors, setErrors] = useState({})

  const [bannerFile, setBannerFile] = useState(null)
  const [bannerUrl, setBannerUrl] = useState(
    universityData?.bannerImage?.url || "",
  )
  const [bannerAlt, setBannerAlt] = useState(
    universityData?.bannerImage?.alt || "",
  )
  const [galleryFiles, setGalleryFiles] = useState([])
  const [galleryUrls, setGalleryUrls] = useState(
    universityData?.gallery?.map(img => img.url) || [],
  )
  const [galleryAltTexts, setGalleryAltTexts] = useState(
    universityData?.gallery?.map(img => img.alt) || [],
  )

  // const [dialCode, phoneNumber] = universityData?.phone
  //   ? universityData?.phone?.split("-")
  //   : [null, null]

  const refinedUniversityData = {
    ...universityData,
    type: {
      name:
        universityData?.type?.charAt(0)?.toUpperCase() +
        universityData?.type?.slice(1),
      code:
        universityData?.type?.charAt(0)?.toUpperCase() +
        universityData?.type?.slice(1),
    },
    country: {
      name: universityData?.country,
      code: universityData?.country,
    },
    ugcApproval: {
      name: universityData?.ugcApproval ? "Yes" : "No",
      code: universityData?.ugcApproval ? "Yes" : "No",
    },
    aiuAffiliation: {
      name: universityData?.aiuAffiliation ? "Yes" : "No",
      code: universityData?.aiuAffiliation ? "Yes" : "No",
    },
    verifiedStatus: {
      name:
        universityData?.verifiedStatus?.charAt(0)?.toUpperCase() +
        universityData?.verifiedStatus?.slice(1),
      code:
        universityData?.verifiedStatus?.charAt(0)?.toUpperCase() +
        universityData?.verifiedStatus?.slice(1),
    },
    verifiedReason: universityData?.verifiedReason || "",
    cutoffs: Array.isArray(universityData?.cutoffs)
      ? universityData.cutoffs
      : [],
    departments: Array.isArray(universityData?.departments)
      ? universityData.departments
      : [],
    reviews: Array.isArray(universityData?.reviews)
      ? universityData.reviews
      : [],
    qsRanking: universityData?.qsRanking || null,
    beddedHospital: universityData?.beddedHospital || null,
    yearlyIntake: universityData?.yearlyIntake,
    gallery: Array.isArray(universityData?.gallery)
      ? universityData.gallery
      : [],
    pixwikShow: {
      name: universityData?.pixwikShow ? "Yes" : "No",
      code: universityData?.pixwikShow ? "Yes" : "No",
    },
  }

  console.log("refinedUniversityData", refinedUniversityData)
  const [updatedUniversityData, setUpdatedUniversityData] = useState(
    refinedUniversityData,
  )

  // Add this useEffect to ensure arrays are properly initialized
  useEffect(() => {
    if (!Array.isArray(updatedUniversityData.cutoffs)) {
      setUpdatedUniversityData(prev => ({ ...prev, cutoffs: [] }))
    }
    if (!Array.isArray(updatedUniversityData.departments)) {
      setUpdatedUniversityData(prev => ({ ...prev, departments: [] }))
    }
    if (!Array.isArray(updatedUniversityData.reviews)) {
      setUpdatedUniversityData(prev => ({ ...prev, reviews: [] }))
    }
    if (!Array.isArray(updatedUniversityData.gallery)) {
      setUpdatedUniversityData(prev => ({ ...prev, gallery: [] }))
    }
  }, [])

  const handleUniverSityDataChange = (name, value) => {
    setUpdatedUniversityData(prevState => ({
      ...prevState,
      [name]: value,
    }))
    setErrors(prevErrors => ({ ...prevErrors, [name]: "" }))
  }

  const handleLogoChange = e => {
    if (e.target.files && e.target.files[0]) {
      setLogoFile(e.target.files[0])
      setLogoUrl("")
    }
  }

  const deleteImage = async imageUrl => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }

      await S3UploadApi.deleteImage({ fileUrl: imageUrl }, config)
      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: "Image deleted successfully",
        life: 3000,
      })
      return true
    } catch (error) {
      console.error("Error deleting image:", error)
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to delete image",
        life: 3000,
      })
      return false
    }
  }

  const handleLogoDelete = async () => {
    if (logoUrl) {
      const success = await deleteImage(logoUrl)
      if (success) {
        setLogoUrl("")
        setLogoAlt("")
        handleUniverSityDataChange("logo", { url: "", alt: "" })
        // Reset the file input
        const fileInput = document.getElementById("logo")
        if (fileInput) {
          fileInput.value = ""
        }
      }
    }
  }

  const uploadLogo = async () => {
    if (!logoFile) return null

    setIsUploading(true)
    try {
      // First delete the existing logo if it exists
      if (logoUrl) {
        await deleteImage(logoUrl)
      }

      const formData = new FormData()
      formData.append("image", logoFile)

      const response = await S3UploadApi.uploadImage(formData)
      const newLogoUrl = response.data.imageUrl

      setLogoUrl(newLogoUrl)
      handleUniverSityDataChange("logo", { url: newLogoUrl, alt: logoAlt })
      setLogoFile(null)
      setIsUploading(false)
      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: "Logo uploaded successfully",
        life: 3000,
      })
      return newLogoUrl
    } catch (error) {
      console.error("Error uploading logo:", error)
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Error uploading logo",
        life: 3000,
      })
      setIsUploading(false)
      return null
    }
  }

  const handleBannerChange = e => {
    if (e.target.files && e.target.files[0]) {
      setBannerFile(e.target.files[0])
      setBannerUrl("")
    }
  }

  const handleBannerDelete = async () => {
    if (bannerUrl) {
      const success = await deleteImage(bannerUrl)
      if (success) {
        setBannerUrl("")
        setBannerAlt("")
        handleUniverSityDataChange("bannerImage", { url: "", alt: "" })
        // Reset the file input
        const fileInput = document.getElementById("banner")
        if (fileInput) {
          fileInput.value = ""
        }
      }
    }
  }

  const handleGalleryChange = e => {
    if (e.target.files) {
      setGalleryFiles([...e.target.files])
    }
  }

  const removeGalleryImage = async indexToRemove => {
    const imageUrl = galleryUrls[indexToRemove]
    const success = await deleteImage(imageUrl)
    if (success) {
      setGalleryUrls(prevUrls =>
        prevUrls.filter((_, index) => index !== indexToRemove),
      )
      setGalleryAltTexts(prevAltTexts =>
        prevAltTexts.filter((_, index) => index !== indexToRemove),
      )

      // Update the gallery data in universityData
      const updatedGallery = galleryUrls
        .filter((_, index) => index !== indexToRemove)
        .map((url, i) => ({
          url,
          alt: galleryAltTexts[i] || "",
        }))
      handleUniverSityDataChange("gallery", updatedGallery)
    }
  }

  const handleGalleryAltTextChange = (index, value) => {
    const newAltTexts = [...galleryAltTexts]
    newAltTexts[index] = value
    setGalleryAltTexts(newAltTexts)

    // Update the gallery data in universityData
    const updatedGallery = galleryUrls.map((url, i) => ({
      url,
      alt: newAltTexts[i] || "",
    }))
    handleUniverSityDataChange("gallery", updatedGallery)
  }

  const uploadBanner = async () => {
    if (!bannerFile) return null

    setIsUploadingBanner(true)
    try {
      // First delete the existing banner if it exists
      if (bannerUrl) {
        await deleteImage(bannerUrl)
      }

      const formData = new FormData()
      formData.append("image", bannerFile)

      const response = await S3UploadApi.uploadImage(formData)
      const newBannerUrl = response.data.imageUrl

      setBannerUrl(newBannerUrl)
      handleUniverSityDataChange("bannerImage", {
        url: newBannerUrl,
        alt: bannerAlt,
      })
      setBannerFile(null)
      setIsUploadingBanner(false)
      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: "Banner uploaded successfully",
        life: 3000,
      })
      return newBannerUrl
    } catch (error) {
      console.error("Error uploading banner:", error)
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Error uploading banner",
        life: 3000,
      })
      setIsUploadingBanner(false)
      return null
    }
  }

  const uploadGalleryImages = async () => {
    if (!galleryFiles.length) return []

    setIsUploadingGallery(true)
    try {
      const uploadPromises = galleryFiles.map(async file => {
        const formData = new FormData()
        formData.append("image", file)

        const response = await S3UploadApi.uploadImage(formData)
        return response.data.imageUrl
      })

      const newGalleryUrls = await Promise.all(uploadPromises)
      const newAltTexts = newGalleryUrls.map(() => "") // Initialize empty alt texts for new images

      setGalleryUrls(prevUrls => [...prevUrls, ...newGalleryUrls])
      setGalleryAltTexts(prevAltTexts => [...prevAltTexts, ...newAltTexts])

      // Update the gallery data in universityData
      const updatedGallery = [...galleryUrls, ...newGalleryUrls].map(
        (url, i) => ({
          url,
          alt: [...galleryAltTexts, ...newAltTexts][i] || "",
        }),
      )
      handleUniverSityDataChange("gallery", updatedGallery)

      setGalleryFiles([])
      setIsUploadingGallery(false)
      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: "Gallery images uploaded successfully",
        life: 3000,
      })
      return newGalleryUrls
    } catch (error) {
      console.error("Error uploading gallery:", error)
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Error uploading gallery images",
        life: 3000,
      })
      setIsUploadingGallery(false)
      return []
    }
  }

  const breadcrumbItems = [
    { label: "Pixwik", link: "#" },
    { label: "University", link: "#" },
    { label: "Edit University", link: "#" },
  ]
  const typeOptions = [
    { name: "Central", code: "Central" },
    { name: "State", code: "State" },
    { name: "Private", code: "Private" },
    { name: "Deemed", code: "Deemed" },
    { name: "Autonomous", code: "Autonomous" },
    { name: "Government", code: "Government" },
  ]
  const approvalOptions = [
    { name: "Yes", code: "Yes" },
    { name: "No", code: "No" },
  ]

  const verficationOption = [
    { name: "Approve", code: "Approve" },
    { name: "Reject", code: "Reject" },
    { name: "Pending", code: "Pending" },
  ]

  const quotaOptions = [
    { name: "OC", code: "OC" },
    { name: "OBC", code: "OBC" },
    { name: "SC", code: "SC" },
    { name: "ST", code: "ST" },
  ]

  const validateUniversity = Yup.object().shape({
    universityName: Yup.string().required("University name is required"),
    displayName: Yup.string().required("Display name is required"),
    type: Yup.string()
      // .oneOf(
      //   ["central", "state", "private", "deemed", "autonomous"],
      //   "Invalid Type",
      // )
      .required("University type required"),
    // yearEstablished: Yup.number()
    //   .typeError("Established year must be a valid number")
    //   .min(1800, "Year cannot be before 1800")
    //   .max(new Date().getFullYear(), "Year cannot be in the future")
    //   .required("Established year is required"),
    country: Yup.string().required("Country is required"),
    state: Yup.string().required("State is required"),
    city: Yup.string().required("City is required"),
    pinCode: Yup.string().required("PinCode is required"),
    address: Yup.string().required("Address is required"),
    // phone: Yup.string()
    //   .matches(/^\+\d{1,3}[-\s]?\d{10}$/, "Invalid phone number")
    //   .required("Phone number is required"),
    // email: Yup.string()
    //   .email("Invalid email format")
    //   .required("Email is required"),
    // officialWebsite: Yup.string().required("officialWebsite is required"),
    // description: Yup.string().required("Description is required"),
    // nirfRanking: Yup.string().required("nirfRanking is required"),
    // indiaToday2023Ranking: Yup.string().required(
    //   "indiaToday2023Ranking is required",
    // ),
    // timesRanking2024: Yup.string().required("timesRanking2024 is required"),
    // campusSize: Yup.string().required("campusSize is required"),
    // noOfStudents: Yup.string().required("noOfStudents is required"),
    // noOfDepartments: Yup.string().required("noOfDepartments is required"),
    // noOfCourses: Yup.string().required("noOfCourses is required"),
    // totalFaculty: Yup.string().required("totalFaculty is required"),
    // ugcApproval: Yup.boolean()
    //   .oneOf([true, false], "Invalid UGC approval")
    //   .required("Choose UGC Approval"),
    // aiuAffiliation: Yup.boolean()
    //   .oneOf([true, false], "Invalid AIU Affiliation")
    //   .required("Choose AIU Affiliation"),
    highlights: Yup.string().required("highlights is required"),
    aboutContent: Yup.string().required("aboutContent is required"),
  })

  const updateUniversity = async () => {
    try {
      console.log(updatedUniversityData)
      setLoading(true)
      // Upload logo first if needed
      if (logoFile && !logoUrl) {
        const uploadedUrl = await uploadLogo()
        if (!uploadedUrl) {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail:
              "Failed to upload logo. Please try uploading again before updating.",
            life: 3000,
          })
          return
        }
      }

      // Upload banner if needed
      if (bannerFile && !bannerUrl) {
        const uploadedBannerUrl = await uploadBanner()
        if (!uploadedBannerUrl) {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail:
              "Failed to upload banner. Please try uploading again before updating.",
            life: 3000,
          })
          return
        }
      }

      // Upload gallery images if needed
      if (galleryFiles.length > 0) {
        const uploadedGalleryUrls = await uploadGalleryImages()
        if (!uploadedGalleryUrls.length) {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail:
              "Failed to upload gallery images. Please try uploading again before updating.",
            life: 3000,
          })
          return
        }
      }

      const { phoneCode, ...otherUniversityData } = updatedUniversityData

      console.log("otherUniversityData", otherUniversityData)
      const payload = {
        ...otherUniversityData,
        logo: {
          url: logoUrl || "",
          alt: logoAlt || "",
        },
        bannerImage: {
          url: bannerUrl || "",
          alt: bannerAlt || "",
        },
        gallery: (galleryUrls || []).map((url, index) => ({
          url,
          alt: galleryAltTexts[index] || "",
        })),
        country: otherUniversityData?.country?.name,
        state: otherUniversityData?.state,
        establishedYear: new Date(
          otherUniversityData?.establishedYear,
        ).getFullYear(),
        city: otherUniversityData?.city,
        type: otherUniversityData?.type?.name?.toLowerCase(),
        aiuAffiliation:
          otherUniversityData?.aiuAffiliation?.name === "Yes" ? true : false,
        ugcApproval:
          otherUniversityData?.ugcApproval?.name === "Yes" ? true : false,
        pixwikShow:
          otherUniversityData?.pixwikShow?.name === "Yes" ? true : false,
        isVerfied: otherUniversityData?.isVerified === "Approve" ? true : false,
        verifiedStatus: otherUniversityData?.verifiedStatus?.name?.toLowerCase()
          ? otherUniversityData?.verifiedStatus?.name?.toLowerCase()
          : "pending",
        verifiedReason: otherUniversityData?.verifiedReason
          ? otherUniversityData?.verifiedReason
          : "",
        qsRanking: otherUniversityData?.qsRanking,
        beddedHospital: otherUniversityData?.beddedHospital,
        yearlyIntake: otherUniversityData?.yearlyIntake,
        cutoffs: otherUniversityData?.cutoffs || [],
        departments: Array.isArray(otherUniversityData?.departments)
          ? otherUniversityData.departments.join(", ")
          : otherUniversityData?.departments || "",
        reviews: otherUniversityData?.reviews || [],
      }

      setLoading(true)
      const config = {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }

      UniversityApi.updateUniversity(payload, config)
        .then(response => {
          if (response.data.status) {
            setLoading(false)
            // Update the local state with the new data
            setUpdatedUniversityData(prev => ({
              ...prev,
              logo: logoUrl,
              bannerImage: bannerUrl,
              gallery: galleryUrls,
            }))
            setTimeout(() => {
              navigate("/universitylist")
            }, 1000)

            toast.current.show({
              severity: "success",
              summary: "Success",
              detail: response.data.message,
              life: 3000,
            })
          }
        })
        .catch(error => {
          setLoading(false)

          const errorMessage =
            error.response && error.response.data && error.response.data.message
              ? error.response.data.message
              : "Unable to update university"
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: errorMessage,
            life: 3000,
          })
        })
    } catch (error) {
      console.error("Unexpected error in updateUniversity:", error)
      setLoading(false)
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "An unexpected error occurred",
        life: 3000,
      })
    }
  }

  useEffect(() => {
    console.log("Logo from university data:", universityData?.logo)
    console.log("Current logo state:", logoUrl)
  }, [])

  return (
    <div className="edit-university">
      <Row>
        <Col xs="12">
          <div className="university-list-header d-flex  align-items-center justify-content-between">
            <CustomBreadCrumb
              data={breadcrumbItems}
              pageTitle="Edit University"
            />
          </div>

          <Card className="mt-4 ">
            <CardBody>
              <div className="university-edit-form ">
                <div className="university-edit-inp">
                  <label htmlFor="universityName" className="label">
                    University Name
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="universityName"
                      value={updatedUniversityData.universityName}
                      onChange={e =>
                        handleUniverSityDataChange(
                          "universityName",
                          e.target.value,
                        )
                      }
                      placeholder="Enter University Name"
                      className="inp-field-box"
                    />
                    {errors.universityName && (
                      <small className="error">{errors.universityName}</small>
                    )}
                  </div>
                </div>
                <div className="university-edit-inp">
                  <label htmlFor="displayName" className="label">
                    Display Name
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="displayName"
                      value={updatedUniversityData.displayName}
                      onChange={e =>
                        handleUniverSityDataChange(
                          "displayName",
                          e.target.value,
                        )
                      }
                      placeholder="Enter Display Name"
                      className="inp-field-box"
                    />
                    {errors.displayName && (
                      <small className="error">{errors.displayName}</small>
                    )}
                  </div>
                </div>
                <div className="university-edit-inp">
                  <label htmlFor="type" className="label">
                    Type
                  </label>

                  <div className="inp-err">
                    <Dropdown
                      value={updatedUniversityData.type}
                      onChange={e =>
                        handleUniverSityDataChange("type", e.value)
                      }
                      options={typeOptions}
                      optionLabel="name"
                      placeholder="Select Type"
                      filter
                      className="inp-field-box"
                    />

                    {errors.type && (
                      <small className="error">{errors.type}</small>
                    )}
                  </div>
                </div>
                <div className="university-edit-inp">
                  <label htmlFor="yearEstablished" className="label">
                    Year Established
                  </label>
                  <div className="inp-err">
                    <Calendar
                      id="yearEstablished"
                      value={
                        updatedUniversityData.yearEstablished
                          ? new Date(updatedUniversityData.yearEstablished, 0)
                          : null
                      }
                      onChange={e => {
                        const selectedYear = e.value
                          ? new Date(e.value).getFullYear()
                          : null
                        handleUniverSityDataChange(
                          "yearEstablished",
                          selectedYear,
                        )
                      }}
                      view="year"
                      dateFormat="yy"
                      placeholder="Select  Year Established"
                      className="inp-field-box"
                    />

                    {errors.establishedYear && (
                      <small className="error">{errors.establishedYear}</small>
                    )}
                  </div>
                </div>

                <div className="university-edit-inp">
                  <label htmlFor="country" className="label">
                    Country
                  </label>
                  <div className="inp-err">
                    <Dropdown
                      id="country"
                      value={updatedUniversityData.country}
                      onChange={e =>
                        handleUniverSityDataChange("country", e.value)
                      }
                      options={Country}
                      optionLabel="name"
                      placeholder="Select Country"
                      filter
                      className="inp-field-box"
                    />

                    {errors.country && (
                      <small className="error">{errors.country}</small>
                    )}
                  </div>
                </div>

                <div className="university-edit-inp">
                  <label htmlFor="state" className="label">
                    State
                  </label>

                  <div className="inp-err">
                    <InputText
                      id="state"
                      value={updatedUniversityData.state}
                      onChange={e =>
                        handleUniverSityDataChange("state", e.target.value)
                      }
                      placeholder="Enter State"
                      className="inp-field-box"
                    />
                    {errors.state && (
                      <small className="error">{errors.state}</small>
                    )}
                  </div>
                </div>

                <div className="university-edit-inp">
                  <label htmlFor="username" className="label">
                    City
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="city"
                      placeholder="Enter City"
                      value={updatedUniversityData.city}
                      onChange={e =>
                        handleUniverSityDataChange("city", e.target.value)
                      }
                      className="inp-field-box"
                    />
                    {errors.city && (
                      <small className="error">{errors.city}</small>
                    )}
                  </div>
                </div>

                <div className="university-edit-inp">
                  <label htmlFor="pincode" className="label">
                    Pin Code
                  </label>
                  <div className="inp-err">
                    <InputNumber
                      id="pinCode"
                      value={updatedUniversityData.pinCode}
                      onChange={e =>
                        handleUniverSityDataChange("pinCode", e.value)
                      }
                      useGrouping={false}
                      placeholder="Enter Pin Code"
                      className="inp-field-box"
                    />
                    {errors.zipCode && (
                      <small className="error">{errors.pinCode}</small>
                    )}
                  </div>
                </div>

                <div className="university-edit-inp">
                  <label htmlFor="address" className="label">
                    Address
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="address"
                      value={updatedUniversityData.address}
                      onChange={e =>
                        handleUniverSityDataChange("address", e.target.value)
                      }
                      placeholder="Enter Address"
                      className="inp-field-box"
                    />

                    {errors.address && (
                      <small className="error">{errors.address}</small>
                    )}
                  </div>
                </div>

                {/* <div className="university-edit-inp">
                  <label htmlFor="phoneNumber" className="label">
                    Phone
                  </label>

                  <div className="inp-err">
                    <div className="p-inputgroup  phone-number ">
                      <Dropdown
                        id="phone"
                        value={updatedUniversityData.country}
                        options={Country}
                        optionLabel="dialCode"
                        placeholder="+XX"
                        filter
                      />
                      <InputNumber
                        id="phoneNumber"
                        value={updatedUniversityData.phone}
                        onChange={e =>
                          handleUniverSityDataChange("phone", e.value)
                        }
                        useGrouping={false}
                        placeholder="Enter Phone Number"
                      />
                    </div>

                    {errors.phone && (
                      <small className="error">{errors.phone}</small>
                    )}
                  </div>
                </div> */}
                <div className="university-edit-inp">
                  <label htmlFor="email" className="label">
                    Email
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="email"
                      value={updatedUniversityData.email}
                      onChange={e =>
                        handleUniverSityDataChange("email", e.target.value)
                      }
                      placeholder="Enter Email"
                      className="inp-field-box"
                    />
                    {errors.email && (
                      <small className="error">{errors.email}</small>
                    )}
                  </div>
                </div>
                {/* <div className="university-edit-inp">
                  <label htmlFor="website" className="label">
                    Website
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="website"
                      value={updatedUniversityData.website}
                      onChange={e =>
                        handleUniverSityDataChange("website", e.target.value)
                      }
                      placeholder="Enter Website"
                      className="inp-field-box"
                    />
                    {errors.website && (
                      <small className="error">{errors.website}</small>
                    )}
                  </div>
                </div> */}
                <div className="university-edit-inp">
                  <label htmlFor="officialWebsite" className="label">
                    Official Website
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="officialWebsite"
                      value={updatedUniversityData.officialWebsite}
                      onChange={e =>
                        handleUniverSityDataChange(
                          "officialWebsite",
                          e.target.value,
                        )
                      }
                      placeholder="Enter Official Website"
                      className="inp-field-box"
                    />
                    {errors.officialWebsite && (
                      <small className="error">{errors.officialWebsite}</small>
                    )}
                  </div>
                </div>
                <div className="university-edit-inp">
                  <label htmlFor="campusSize" className="label">
                    Campus Size
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="campusSize"
                      value={updatedUniversityData.campusSize}
                      onChange={e =>
                        handleUniverSityDataChange("campusSize", e.target.value)
                      }
                      placeholder="Enter CampusSize"
                      className="inp-field-box"
                    />
                    {errors.campusSize && (
                      <small className="error">{errors.campusSize}</small>
                    )}
                  </div>
                </div>

                <div className="university-edit-inp">
                  <label htmlFor="noOfStudents" className="label">
                    No Of Students
                  </label>
                  <div className="inp-err">
                    <InputNumber
                      id="noOfStudents"
                      value={updatedUniversityData.noOfStudents}
                      onChange={e =>
                        handleUniverSityDataChange("noOfStudents", e.value)
                      }
                      placeholder="Enter No Of Students"
                      className="inp-field-box"
                    />
                    {errors.noOfStudents && (
                      <small className="error">{errors.noOfStudents}</small>
                    )}
                  </div>
                </div>

                <div className="university-edit-inp">
                  <label htmlFor="noOfDepartments" className="label">
                    No Of Departments
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="noOfDepartments"
                      value={updatedUniversityData.noOfDepartments}
                      onChange={e =>
                        handleUniverSityDataChange(
                          "noOfDepartments",
                          e.target.value,
                        )
                      }
                      placeholder="Enter No Of Departments"
                      className="inp-field-box"
                    />
                    {errors.noOfDepartments && (
                      <small className="error">{errors.noOfDepartments}</small>
                    )}
                  </div>
                </div>
                <div className="university-edit-inp">
                  <label htmlFor="noOfCourses" className="label">
                    No Of Courses
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="noOfCourses"
                      value={updatedUniversityData.noOfCourses}
                      onChange={e =>
                        handleUniverSityDataChange(
                          "noOfCourses",
                          e.target.value,
                        )
                      }
                      placeholder="Enter No Of Courses"
                      className="inp-field-box"
                    />
                    {errors.noOfCourses && (
                      <small className="error">{errors.noOfCourses}</small>
                    )}
                  </div>
                </div>
                <div className="university-edit-inp">
                  <label htmlFor="totalFaculty" className="label">
                    Total Faculty
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="totalFaculty"
                      value={updatedUniversityData.totalFaculty}
                      onChange={e =>
                        handleUniverSityDataChange(
                          "totalFaculty",
                          e.target.value,
                        )
                      }
                      placeholder="Enter Total Faculty"
                      className="inp-field-box"
                    />
                    {errors.totalFaculty && (
                      <small className="error">{errors.totalFaculty}</small>
                    )}
                  </div>
                </div>
                <div className="university-edit-inp">
                  <label htmlFor="nirfRanking" className="label">
                    NIRF Ranking
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="nirfRanking"
                      value={updatedUniversityData.nirfRanking}
                      onChange={e =>
                        handleUniverSityDataChange(
                          "nirfRanking",
                          e.target.value,
                        )
                      }
                      placeholder="Enter NIRF Ranking"
                      className="inp-field-box"
                    />
                    {errors.nirfRanking && (
                      <small className="error">{errors.nirfRanking}</small>
                    )}
                  </div>
                </div>

                <div className="university-edit-inp">
                  <label htmlFor="indiaToday2023Ranking" className="label">
                    India Today 2023 Ranking
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="indiaToday2023Ranking"
                      value={updatedUniversityData.indiaToday2023Ranking}
                      onChange={e =>
                        handleUniverSityDataChange(
                          "indiaToday2023Ranking",
                          e.target.value,
                        )
                      }
                      placeholder="Enter India Today 2023 Ranking"
                      className="inp-field-box"
                    />
                    {errors.indiaToday2023Ranking && (
                      <small className="error">
                        {errors.indiaToday2023Ranking}
                      </small>
                    )}
                  </div>
                </div>
                <div className="university-edit-inp">
                  <label htmlFor="timesRanking2024" className="label">
                    Times Ranking 2024
                  </label>
                  <div className="inp-err">
                    <InputNumber
                      id="timesRanking2024"
                      value={updatedUniversityData.timesRanking2024}
                      onChange={e =>
                        handleUniverSityDataChange("timesRanking2024", e.value)
                      }
                      placeholder="Enter Times Ranking 2024"
                      className="inp-field-box"
                    />
                    {errors.timesRanking2024 && (
                      <small className="error">{errors.timesRanking2024}</small>
                    )}
                  </div>
                </div>
                <div className="university-edit-inp">
                  <label htmlFor="qsRanking" className="label">
                    QS Ranking
                  </label>
                  <div className="inp-err">
                    <InputNumber
                      id="qsRanking"
                      value={updatedUniversityData.qsRanking}
                      onChange={e =>
                        handleUniverSityDataChange("qsRanking", e.value)
                      }
                      placeholder="Enter QS Ranking"
                      className="inp-field-box"
                    />
                  </div>
                </div>

                <div className="university-edit-inp">
                  <label htmlFor="beddedHospital" className="label">
                    Bedded Hospital
                  </label>
                  <div className="inp-err">
                    <InputNumber
                      id="beddedHospital"
                      value={updatedUniversityData.beddedHospital}
                      onChange={e =>
                        handleUniverSityDataChange("beddedHospital", e.value)
                      }
                      placeholder="Enter Bedded Hospital Count"
                      className="inp-field-box"
                    />
                  </div>
                </div>

                <div className="university-edit-inp">
                  <label htmlFor="yearlyIntake" className="label">
                    Yearly Intake
                  </label>
                  <div className="inp-err">
                    <InputNumber
                      id="yearlyIntake"
                      value={updatedUniversityData.yearlyIntake}
                      onChange={e =>
                        handleUniverSityDataChange("yearlyIntake", e.value)
                      }
                      placeholder="Enter Yearly Intake"
                      className="inp-field-box"
                    />
                  </div>
                </div>
                {/* <div className="university-edit-inp">
                  <label htmlFor="departments" className="label">
                    Departments
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="departments"
                      value={updatedUniversityData.departments}
                      onChange={e =>
                        handleUniverSityDataChange("departments", e.value)
                      }
                      placeholder="Enter Departments"
                      className="inp-field-box"
                    />
                  </div>
                </div> */}

                <div className="university-edit-inp">
                  <label htmlFor="ugcApproval" className="label">
                    UGC Approval
                  </label>
                  <div className="inp-err ">
                    <Dropdown
                      value={updatedUniversityData.ugcApproval}
                      onChange={e =>
                        handleUniverSityDataChange("ugcApproval", e.value)
                      }
                      options={approvalOptions}
                      optionLabel="name"
                      placeholder="Select UGC Affiliation"
                      className="inp-field-box"
                    />
                    {errors.ugcApproval && (
                      <small className="error">{errors.ugcApproval}</small>
                    )}
                  </div>
                </div>
                <div className="university-edit-inp">
                  <label htmlFor="aiuAffiliation" className="label">
                    AIU Affiliation
                  </label>
                  <div className="inp-err">
                    <Dropdown
                      value={updatedUniversityData.aiuAffiliation}
                      onChange={e =>
                        handleUniverSityDataChange("aiuAffiliation", e.value)
                      }
                      options={approvalOptions}
                      optionLabel="name"
                      placeholder="Select AIU Affiliation"
                      className="inp-field-box"
                    />
                    {errors.aiuAffiliation && (
                      <small className="error">{errors.aiuAffiliation}</small>
                    )}
                  </div>
                </div>

                <div className="university-edit-inp">
                  <label htmlFor="pixwikShow" className="label">
                    Pixwik Show
                  </label>
                  <div className="inp-err">
                    <Dropdown
                      value={updatedUniversityData.pixwikShow}
                      onChange={e =>
                        handleUniverSityDataChange("pixwikShow", e.value)
                      }
                      options={approvalOptions}
                      optionLabel="name"
                      placeholder="Select Pixwik Show"
                      className="inp-field-box"
                    />
                  </div>
                </div>
                <div className="university-edit-inp">
                  <label htmlFor="highlights" className="label">
                    Highlights
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="highlights"
                      value={updatedUniversityData.highlights}
                      onChange={e =>
                        handleUniverSityDataChange("highlights", e.target.value)
                      }
                      placeholder="Enter Highlights"
                      className="inp-field-box"
                    />
                    {errors.highlights && (
                      <small className="error">{errors.highlights}</small>
                    )}
                  </div>
                </div>
                <div className="university-edit-inp">
                  <label htmlFor="aboutContent" className="label">
                    About Content
                  </label>
                  <div className="inp-err">
                    <InputText
                      id="aboutContent"
                      value={updatedUniversityData.aboutContent}
                      onChange={e =>
                        handleUniverSityDataChange(
                          "aboutContent",
                          e.target.value,
                        )
                      }
                      placeholder="Enter About Content"
                      className="inp-field-box"
                    />
                    {errors.aboutContent && (
                      <small className="error">{errors.highlights}</small>
                    )}
                  </div>
                </div>

                {userData.role === "manager" && (
                  <>
                    <div className="university-edit-inp">
                      <label htmlFor="verifiedStatus" className="label">
                        Verification
                      </label>
                      <div className="inp-err ">
                        <Dropdown
                          id="verifiedStatus"
                          value={updatedUniversityData.verifiedStatus}
                          onChange={e =>
                            handleUniverSityDataChange(
                              "verifiedStatus",
                              e.value,
                            )
                          }
                          options={verficationOption}
                          optionLabel="name"
                          placeholder="Select Verification Status"
                          className="inp-field-box"
                        />
                        {errors.verifiedStatus && (
                          <small className="error">
                            {errors.verifiedStatus}
                          </small>
                        )}
                      </div>
                    </div>

                    <div className="university-edit-inp">
                      <label htmlFor="verifiedReason" className="label">
                        Verification Reason
                      </label>
                      <div className="inp-err">
                        <InputText
                          id="verifiedReason"
                          value={updatedUniversityData.verifiedReason}
                          onChange={e =>
                            handleUniverSityDataChange(
                              "verifiedReason",
                              e.target.value,
                            )
                          }
                          placeholder="Enter Verification Reason"
                          className="inp-field-box"
                        />
                        {errors.verifiedReason && (
                          <small className="error">
                            {errors.verifiedReason}
                          </small>
                        )}
                      </div>
                    </div>
                  </>
                )}

                <div className="university-edit-inp">
                  <label htmlFor="logo" className="label">
                    Logo
                  </label>
                  <div className="inp-err">
                    {logoUrl && (
                      <div className="mb-2 position-relative">
                        <img
                          src={logoUrl}
                          alt={logoAlt || "University Logo"}
                          style={{
                            width: "100px",
                            height: "auto",
                            objectFit: "contain",
                            border: "1px solid #ddd",
                            borderRadius: "4px",
                            padding: "2px",
                          }}
                        />
                        <Button
                          type="button"
                          color="danger"
                          size="sm"
                          className="position-absolute top-0 end-0"
                          style={{ margin: "2px" }}
                          onClick={handleLogoDelete}
                        >
                          ×
                        </Button>
                      </div>
                    )}
                    {logoFile && (
                      <div className="mb-2">
                        <small>Selected file: {logoFile.name}</small>
                      </div>
                    )}
                    <div className="d-flex align-items-center gap-2">
                      <input
                        type="file"
                        name="logo"
                        id="logo"
                        accept="image/*"
                        onChange={handleLogoChange}
                      />
                      {logoFile && !isUploading && (
                        <Button
                          type="button"
                          color="primary"
                          size="sm"
                          className="waves-effect waves-light"
                          onClick={() => uploadLogo()}
                        >
                          Upload
                        </Button>
                      )}
                    </div>
                    {isUploading && (
                      <small className="d-block mt-1">
                        <Spinner size="sm" /> Uploading logo...
                      </small>
                    )}
                    {logoUrl && (
                      <div className="mt-2">
                        <label htmlFor="logoAltText">Logo Alt Text</label>
                        <InputText
                          id="logoAltText"
                          name="logoAltText"
                          className="w-100"
                          placeholder="Enter descriptive text for the logo"
                          value={logoAlt}
                          onChange={e => {
                            setLogoAlt(e.target.value)
                            handleUniverSityDataChange("logo", {
                              url: logoUrl,
                              alt: e.target.value,
                            })
                          }}
                        />
                      </div>
                    )}
                  </div>
                </div>

                <div className="university-edit-inp">
                  <label htmlFor="banner" className="label">
                    Banner Image
                  </label>
                  <div className="inp-err">
                    {bannerUrl && (
                      <div className="mb-2 position-relative">
                        <img
                          src={bannerUrl}
                          alt={bannerAlt || "University Banner"}
                          style={{
                            width: "200px",
                            height: "auto",
                            objectFit: "contain",
                            border: "1px solid #ddd",
                            borderRadius: "4px",
                            padding: "2px",
                          }}
                        />
                        <Button
                          type="button"
                          color="danger"
                          size="sm"
                          className="position-absolute top-0 end-0"
                          style={{ margin: "2px" }}
                          onClick={handleBannerDelete}
                        >
                          ×
                        </Button>
                      </div>
                    )}
                    {bannerFile && (
                      <div className="mb-2">
                        <small>Selected file: {bannerFile.name}</small>
                      </div>
                    )}
                    <div className="d-flex align-items-center gap-2">
                      <input
                        type="file"
                        name="banner"
                        id="banner"
                        accept="image/*"
                        onChange={handleBannerChange}
                      />
                      {bannerFile && !isUploadingBanner && (
                        <Button
                          type="button"
                          color="primary"
                          size="sm"
                          className="waves-effect waves-light"
                          onClick={uploadBanner}
                        >
                          Upload Banner
                        </Button>
                      )}
                    </div>
                    {isUploadingBanner && (
                      <small className="d-block mt-1">
                        <Spinner size="sm" /> Uploading banner...
                      </small>
                    )}
                    {bannerUrl && (
                      <div className="mt-2">
                        <label htmlFor="bannerAltText">Banner Alt Text</label>
                        <InputText
                          id="bannerAltText"
                          name="bannerAltText"
                          className="w-100"
                          placeholder="Enter descriptive text for the banner"
                          value={bannerAlt}
                          onChange={e => {
                            setBannerAlt(e.target.value)
                            handleUniverSityDataChange("bannerImage", {
                              url: bannerUrl,
                              alt: e.target.value,
                            })
                          }}
                        />
                      </div>
                    )}
                  </div>
                </div>

                <div className="university-edit-inp">
                  <label htmlFor="gallery" className="label">
                    Gallery Images
                  </label>
                  <div className="inp-err">
                    {(galleryUrls || []).length > 0 && (
                      <div className="mb-3 d-flex flex-wrap gap-2">
                        {(galleryUrls || []).map((url, index) => (
                          <div key={index} className="position-relative">
                            <img
                              src={url}
                              alt={
                                galleryAltTexts[index] || `Gallery ${index + 1}`
                              }
                              style={{
                                width: "100px",
                                height: "100px",
                                objectFit: "cover",
                                borderRadius: "4px",
                              }}
                            />
                            <Button
                              type="button"
                              color="danger"
                              size="sm"
                              className="position-absolute top-0 end-0 p-1"
                              onClick={() => removeGalleryImage(index)}
                            >
                              ×
                            </Button>
                            <div className="mt-2">
                              <InputText
                                placeholder="Enter alt text for this image"
                                value={galleryAltTexts[index] || ""}
                                onChange={e =>
                                  handleGalleryAltTextChange(
                                    index,
                                    e.target.value,
                                  )
                                }
                                className="w-100"
                              />
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                    <div className="d-flex align-items-center gap-2">
                      <input
                        type="file"
                        name="gallery"
                        id="gallery"
                        accept="image/*"
                        multiple
                        onChange={handleGalleryChange}
                      />
                      {galleryFiles.length > 0 && !isUploadingGallery && (
                        <Button
                          type="button"
                          color="primary"
                          size="sm"
                          className="waves-effect waves-light"
                          onClick={uploadGalleryImages}
                        >
                          Upload Gallery
                        </Button>
                      )}
                    </div>
                    {galleryFiles.length > 0 && (
                      <div className="mt-2">
                        <small>Selected files: {galleryFiles.length}</small>
                      </div>
                    )}
                  </div>
                </div>

                {/* <div className="cutoffs-section mt-4">
                  <h5 className="border-bottom pb-2 mb-3">Cutoff Details</h5>
                  {(updatedUniversityData?.cutoffs || []).map(
                    (cutoff, index) => (
                      <div
                        key={index}
                        className="cutoff-item border rounded p-3 mb-3"
                      >
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <h6 className="mb-0">Cutoff {index + 1}</h6>
                          <Button
                            type="button"
                            color="danger"
                            size="sm"
                            onClick={() => {
                              const newCutoffs = [
                                ...updatedUniversityData.cutoffs,
                              ]
                              newCutoffs.splice(index, 1)
                              handleUniverSityDataChange("cutoffs", newCutoffs)
                            }}
                          >
                            Remove
                          </Button>
                        </div>
                        <div className="row g-3">
                          <div className="col-md-6">
                            <InputText
                              placeholder="Year"
                              value={cutoff.year}
                              onChange={e => {
                                const newCutoffs = [
                                  ...updatedUniversityData.cutoffs,
                                ]
                                newCutoffs[index].year = e.target.value
                                handleUniverSityDataChange(
                                  "cutoffs",
                                  newCutoffs,
                                )
                              }}
                            />
                          </div>
                          <div className="col-md-6">
                            <Dropdown
                              value={{ name: cutoff.quota, code: cutoff.quota }}
                              options={quotaOptions}
                              optionLabel="name"
                              placeholder="Select Quota"
                              className="inp-field-box"
                              onChange={e => {
                                const newCutoffs = [
                                  ...updatedUniversityData.cutoffs,
                                ]
                                newCutoffs[index].quota = e.value.code
                                handleUniverSityDataChange(
                                  "cutoffs",
                                  newCutoffs,
                                )
                              }}
                            />
                          </div>
                          <div className="col-md-6">
                            <InputText
                              placeholder="Round 1"
                              value={cutoff.rounds.round1}
                              onChange={e => {
                                const newCutoffs = [
                                  ...updatedUniversityData.cutoffs,
                                ]
                                newCutoffs[index].rounds.round1 = e.target.value
                                handleUniverSityDataChange(
                                  "cutoffs",
                                  newCutoffs,
                                )
                              }}
                            />
                          </div>
                          <div className="col-md-6">
                            <InputText
                              placeholder="Round 2"
                              value={cutoff.rounds.round2}
                              onChange={e => {
                                const newCutoffs = [
                                  ...updatedUniversityData.cutoffs,
                                ]
                                newCutoffs[index].rounds.round2 = e.target.value
                                handleUniverSityDataChange(
                                  "cutoffs",
                                  newCutoffs,
                                )
                              }}
                            />
                          </div>
                          <div className="col-md-6">
                            <InputText
                              placeholder="Mop-Up Round"
                              value={cutoff.rounds.mopUpRound}
                              onChange={e => {
                                const newCutoffs = [
                                  ...updatedUniversityData.cutoffs,
                                ]
                                newCutoffs[index].rounds.mopUpRound =
                                  e.target.value
                                handleUniverSityDataChange(
                                  "cutoffs",
                                  newCutoffs,
                                )
                              }}
                            />
                          </div>
                          <div className="col-md-6">
                            <InputText
                              placeholder="Stray Vacancy"
                              value={cutoff.rounds.strayVacancy}
                              onChange={e => {
                                const newCutoffs = [
                                  ...updatedUniversityData.cutoffs,
                                ]
                                newCutoffs[index].rounds.strayVacancy =
                                  e.target.value
                                handleUniverSityDataChange(
                                  "cutoffs",
                                  newCutoffs,
                                )
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    ),
                  )}
                  <Button
                    type="button"
                    color="primary"
                    size="sm"
                    onClick={() => {
                      const newCutoff = {
                        year: "",
                        quota: "",
                        rounds: {
                          round1: "",
                          round2: "",
                          mopUpRound: "",
                          strayVacancy: "",
                        },
                      }
                      handleUniverSityDataChange("cutoffs", [
                        ...(updatedUniversityData.cutoffs || []),
                        newCutoff,
                      ])
                    }}
                  >
                    Add Cutoff
                  </Button>
                </div> */}

                <div className="reviews-section mt-4">
                  <h5 className="border-bottom pb-2 mb-3">Reviews</h5>
                  {(updatedUniversityData?.reviews || []).length > 0 ? (
                    <Row className="g-4">
                      {updatedUniversityData.reviews.map((review, index) => (
                        <Col md="6" lg="4" key={index}>
                          <Card className="review-card h-100 p-3">
                            <div className="d-flex justify-content-end mb-2">
                              <Button
                                type="button"
                                color="danger"
                                size="sm"
                                onClick={() => {
                                  const newReviews = [
                                    ...updatedUniversityData.reviews,
                                  ]
                                  newReviews.splice(index, 1)
                                  handleUniverSityDataChange(
                                    "reviews",
                                    newReviews,
                                  )
                                }}
                              >
                                ×
                              </Button>
                            </div>
                            <div className="review-header d-flex align-items-center gap-3 mb-3">
                              <Avatar
                                label={
                                  review.name?.charAt(0)?.toUpperCase() || "U"
                                }
                                size="large"
                                shape="circle"
                                style={{
                                  backgroundColor:
                                    "#" +
                                    Math.floor(
                                      Math.random() * 16777215,
                                    ).toString(16),
                                  color: "#ffffff",
                                  padding: "10px",
                                }}
                              />
                              <div>
                                <h6 className="mb-1">{review.name}</h6>
                                <small className="text-muted">
                                  {review.createdAt
                                    ? formatDistanceToNow(
                                        new Date(review.createdAt),
                                        { addSuffix: true },
                                      )
                                    : "Recently added"}
                                </small>
                              </div>
                            </div>

                            <div className="review-content">
                              <p className="mb-0" style={{ lineHeight: "1.6" }}>
                                {review.review}
                              </p>
                            </div>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  ) : (
                    <div className="text-center py-5">
                      <p>No reviews available</p>
                    </div>
                  )}
                </div>
              </div>

              <div className="save-cancel-btn mt-4 d-flex align-items-center justify-content-end gap-3">
                <Button
                  type="button"
                  outline
                  color="danger"
                  className="waves-effect waves-light"
                  onClick={() => {
                    navigate(-1)
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type="button"
                  color="secondary"
                  className="waves-effect waves-light"
                  disabled={loading}
                  onClick={() => {
                    updateUniversity()
                  }}
                >
                  {loading ? <Spinner size="sm" /> : "Update"}
                </Button>
                <Toast ref={toast} />
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default EditUniversity
